import { css, useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { media } from '@dfds-ui/theme'

const StopColor = styled.stop`
  stop-color: ${(props) => props.theme['color-shafts']};
  fill: ${(props) => props.theme['color-shafts']};
`
const Stripes = () => {
  const themeContext = useTheme()

  const useColor = {
    stopColor: themeContext['color-shafts'],
    fill: themeContext['color-shafts'],
  }

  return (
    <div
      css={css`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
      `}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 809 603"
        css={css`
          position: absolute;
          left: -400px;
          top: -400px;
          width: 800px;

          ${media.greaterThan('m')`
            left: -400px;
            top: -200px;
          `}

          ${media.greaterThan('l')`
            left: 0;
            top: 0;
          `}
        `}
      >
        <defs>
          <linearGradient
            id="leftShaftGradA"
            x1="50%"
            x2="50%"
            y1="0%"
            y2="100%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity=".7" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="leftShaftGradB"
            x1="100%"
            x2="24.236%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".5" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="leftShaftGradC"
            x1="100%"
            x2="0%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="leftShaftGradD"
            x1="100%"
            x2="0%"
            y1="50.002%"
            y2="50.002%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".3" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="leftShaftGradE" x1="11.903%" y1="50%" y2="50%">
            <StopColor offset="0%" stopColor="#C3E0F4" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity=".4" />
          </linearGradient>
          <rect id="leftShaftGradF" width="372" height="603" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <polygon
            fill="url(#leftShaftGradA)"
            fillRule="nonzero"
            points="371 0 687 0 445.084 603 371 603"
          />
          <polygon
            fill="url(#leftShaftGradB)"
            fillRule="nonzero"
            points="664.828 0 739 0 490.172 603 416 603"
          />
          <polygon
            fill="url(#leftShaftGradC)"
            fillRule="nonzero"
            points="734.598 0 809 0 559.402 603 485 603"
            opacity=".1"
          />
          <polygon
            fill="url(#leftShaftGradD)"
            fillRule="nonzero"
            points="705.551 0 715 0 714.373 1.057 466.449 603 457 603 704.968 .983"
          />
          <polygon
            fill="url(#leftShaftGradE)"
            fillRule="nonzero"
            points="371 603 376.5 603 613 0 371 0"
          />
          <rect
            fill={useColor.fill}
            fillRule="nonzero"
            width="372"
            height="603"
          ></rect>
        </g>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="300"
        height="603"
        viewBox="0 0 300 603"
        css={css`
          position: absolute;
          right: 0;
          bottom: -300px;
          width: 300px;

          ${media.greaterThan('m')`
            bottom: -150px;
          `}

          ${media.greaterThan('l')`
            bottom: 0;
          `}
        `}
      >
        <defs>
          <rect id="righgtShaftExportA" width="300" height="603" />
          <linearGradient
            id="rightShaftExportB"
            x1="50%"
            x2="50%"
            y1="0%"
            y2="100%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity=".7" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity="0" />
          </linearGradient>
          <polygon
            id="rightShaftExportC"
            points="316 604 0 604 241.916 0 316 0"
          />
          <linearGradient
            id="rightShaftExportD"
            x1="100%"
            x2="1.587%"
            y1="50%"
            y2="50%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity="0" />
            <StopColor offset="100%" stopColor="#C3E0F4" stopOpacity=".4" />
          </linearGradient>
          <polygon
            id="rightShaftExportE"
            points="74.172 603 0 603 248.828 0 323 0"
          />
          <linearGradient
            id="rightShaftExportF"
            x1="100%"
            x2="20.222%"
            y1="50.002%"
            y2="50.002%"
          >
            <stop offset="0%" stopColor="#FFF" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="rightShaftExportG"
            x1="100%"
            x2="17.098%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFF" stopOpacity=".3" />
            <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="rightShaftExportH"
            x1="0%"
            x2="50%"
            y1="61.13%"
            y2="61.13%"
          >
            <StopColor offset="0%" stopColor="#C3E0F4" stopOpacity="0" />
            <StopColor offset="100%" stopColor="#C3E0F4" />
          </linearGradient>
          <polygon
            id="rightShaftExportI"
            points="242 0 236.5 0 0 604 242 604"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="rightShaftExportJ" fill="#fff">
            <use xlinkHref="#righgtShaftExportA" />
          </mask>
          <g mask="url(#rightShaftExportJ)">
            <g transform="translate(6 -1)">
              <g transform="translate(121)">
                <use
                  fill="url(#rightShaftExportB)"
                  fillRule="nonzero"
                  xlinkHref="#rightShaftExportC"
                />
              </g>
              <g transform="translate(68 1)">
                <use
                  fill="url(#rightShaftExportD)"
                  fillRule="nonzero"
                  xlinkHref="#rightShaftExportE"
                />
              </g>
              <polygon
                fill="url(#rightShaftExportF)"
                fillRule="nonzero"
                points="74.272 603.986 0 603.986 249.163 0 323.435 0"
                opacity=".1"
              />
              <polygon
                fill="url(#rightShaftExportG)"
                fillRule="nonzero"
                points="100.412 421 91 421 338.602 1 348 1"
              />
              <g transform="translate(195)">
                <use
                  fill="url(#rightShaftExportH)"
                  fillRule="nonzero"
                  xlinkHref="#rightShaftExportI"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}

const HeroStripes = () => {
  return <Stripes />
}

export default HeroStripes
